import { P } from "@nested/nested-react-components";
import { Quote } from "./Quote";
import { Image } from "./Image";

export const text = (block) => <P>{block.value}</P>;
export const quote = (block) => <Quote>{block.value}</Quote>;
export const image = (block) => <Image src={block.value.url} />;
